export const ROUTE_PATH = '/admin/projects';
export const TITLE = 'Projects';
